import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const faqs = [{
  q: '¿Cómo funciona el demo de $25?',
  a: 'Pagas solo $25 y te construimos un demo real de tu website con tu información, tus fotos y tus servicios. Si te gusta, pagas los $225 restantes y lo lanzamos. Si no te gusta, ahí termina — solo se te cobró el demo.'
}, {
  q: '¿Cuánto cuesta el website completo?',
  a: '$250 en total. Empiezas con $25 por el demo y los $225 restantes solo los pagas si decides lanzarlo. Sin mensualidades obligatorias ni costos ocultos.'
}, {
  q: '¿Los $25 del demo se descuentan del total?',
  a: 'Sí. Los $25 forman parte de los $250 — por eso el resto son solo $225 cuando decides seguir adelante.'
}, {
  q: '¿Por qué es tan barato?',
  a: 'Porque nos especializamos solo en contractors y tenemos un proceso súper eficiente: usamos una estructura comprobada que adaptamos a tu negocio, sin agencias caras de por medio ni meses de trabajo. Preferimos cobrar accesible y ganar por volumen y referidos, no inflando el precio. Mismo resultado profesional, sin el costo de una agencia tradicional.'
}, {
  q: '¿Cuánto necesito para empezar?',
  a: 'Solo $25. Con eso apartamos tu lugar y construimos el demo de tu website.'
}, {
  q: '¿Cuándo pago el resto?',
  a: 'Los $225 restantes los pagas solo cuando veas tu demo terminado y decidas que lo quieres. Nunca antes.'
}, {
  q: '¿El dominio está incluido?',
  a: 'Sí, el dominio viene incluido por 1 año. Al terminar ese año se renueva por separado con un costo anual, y te avisamos con tiempo antes de que venza.'
}, {
  q: '¿Hay mensualidades?',
  a: 'No hay mensualidades obligatorias. Ofrecemos un plan opcional de mantenimiento por $30/mes si lo deseas.'
}, {
  q: '¿Qué incluye el mantenimiento de $30?',
  a: 'Actualización de fotos, cambios de contenido, soporte técnico y comunicación directa por WhatsApp.'
}, {
  q: '¿Cuánto tiempo tarda?',
  a: 'Menos de 72 horas una vez que tengamos toda la información de tu negocio.'
}, {
  q: '¿Qué información necesitan?',
  a: 'Nombre del negocio, servicios, fotos, número de contacto, área de servicio y cualquier detalle importante.'
}, {
  q: '¿Cómo los contacto?',
  a: 'Por WhatsApp al +44 7311 754270 — escríbenos "WEBSITE" y te atendemos hoy.'
}, {
  q: '¿Trabajan con todos los contractors?',
  a: 'Sí — roofing, landscaping, tree service, construcción, pressure washing, HVAC, plomería, junk removal y más.'
}, {
  q: '¿Qué pasa si no me gusta el diseño?',
  a: 'Primero hacemos revisiones hasta que quede como lo quieres. Y si aun así no te convence, simplemente no pagas el resto — solo se te cobró el demo de $25.'
}, {
  q: '¿Necesito saber algo técnico?',
  a: 'Absolutamente no. Nosotros manejamos todo. Tú solo nos das la información y apruebas el resultado.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-24 bg-dark" data-id="element-1" data-mp="1k5yqof7fufd7">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2" data-mp="1f5u6of7bn2i8">
        <div className="text-center mb-16" data-id="element-3" data-mp="1f7ov43hsxcr2">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-4" data-mp="1b3h4g0rs9mq7">
            ¿Tienes Preguntas?{' '}
            <span className="text-gold" data-id="element-5" data-mp="165nvx130cgmr">Tenemos Respuestas.</span>
          </h2>
        </div>

        <div className="space-y-4" data-id="element-6" data-mp="22vesd5uv0dv7">
          {faqs.map((faq, index) => <div key={index} className="bg-dark-100 border border-white/10 rounded-2xl overflow-hidden transition-all duration-300" data-id="element-7" data-mp="1yttk5xt9snrc" data-mpi={index}>
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-8" data-mp="1u0qn3fpaaw6e">
                <span className="text-white font-bold pr-8" data-id="element-9" data-mp="2hspd75te6w3l">{faq.q}</span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-gold shrink-0" data-id="element-10" data-mp="21cn7p36psqgh" /> : <ChevronDown className="w-5 h-5 text-gray-500 shrink-0" data-id="element-11" data-mp="26cj3if59dbky" />}
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-12" data-mp="1sd9wa4z15rt4">
                <p className="text-gray-400 text-sm border-t border-white/5 pt-4" data-id="element-13" data-mp="2l1yr5m9ht0wf">
                  {faq.a}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}